<template>
  <!-- 实践课详情填报Form -->
  <div class="contentdetail">
    <div class="content-container">
      <!-- 审核状态 -->
      <div class="warp" :style="{ height: isOpen ? 'auto' : '40px' }">
        <p class="text" :class="isOpen ? '' : 'clamp'">
          审核状态：
          <span>{{ state }}</span>
          <template v-if="reviewInfo.reviewStatus == '4'">驳回原因：{{ reviewInfo.reviewRemark }}</template>
          <template v-if="reviewInfo.reviewStatus == '5'">驳回原因：{{ reviewInfo.siteCheckRemark }}</template>
          <!-- <template v-if="reviewInfo.reviewStatus == '6'">备注说明：{{ reviewInfo.reviewRemark || reviewInfo.siteCheckRemark }}</template> -->
        </p>
        <span class="butn" v-if="reviewInfo.reviewStatus == '4' && reviewInfo.reviewRemark.length > 20" @click="isOpen = !isOpen">
          <a-icon :type="isOpen ? 'up' : 'down'" />
        </span>
      </div>

      <div class="course-notice" v-if="!article.allowStudy">
        <a-icon type="sound" style="padding-right: 12px" />
        <span>当前时间不在课程允许学习时间范围内，仅供预览、资料下载</span>
      </div>

      <!-- 课程标题 -->
      <div class="cl">
        <div class="title text-center">{{ article.title }}</div>
        <div class="desc" v-html="article.content"></div>
      </div>
      <!-- 课程附件 -->
      <div class="studentinfomation" v-if="article.docList && article.docList.length > 0">
        <div class="">此文档包含以下附件:</div>
        <div style="margin-top: 16px">
          <a-row class="docList" :gutter="[24, 24]">
            <a-col :span="8" v-for="item in article.docList" :key="item.id">
              <div class="filestyle">
                <div
                  class="defaultcss"
                  :class="{
                    pdfcss: item.docName.includes('pdf'),
                    doccss: item.docName.includes('doc'),
                    xlscss: item.docName.includes('xls'),
                  }"
                >
                  <span>{{ item.docName }}</span>
                </div>
                <div class="downicon" @click="downloadDoc(item.docUrl, item.docName)">
                  <img src="../../../assets/images/downicon.png" />
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>

    <div class="upfile">
      <div style="height: 36px;">
        <span style="font-weight: 600;">我的回传文件</span>
      </div>
      <!-- 自定义配置字段 -->
      <div class="margin-bottom-20" style="clear: both">
        <div class="visibles" v-if="article.visibles && article.visibles.length > 0">
          <a-form-model ref="form" :model="formData" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
            <a-row>
              <a-col :span="12" v-for="item in article.visibles" :key="item.label">
                <a-form-model-item
                  v-if="item.show"
                  :label="item.title"
                  :prop="item.label"
                  :rules="[{ required: item.required, message: `${item.title}不能为空` }]"
                  style="width: 100%"
                >
                  <!-- 日期选择框 -->
                  <a-date-picker v-if="item.type == 'date'" valueFormat="YYYY-MM-DD" v-model="formData[item.label]" placeholder="请选择" style="width: 100%" />
                  <!-- 数字输入框 -->
                  <a-input-number
                    v-if="item.type == 'number'"
                    v-model.trim="formData[item.label]"
                    placeholder="请输入"
                    :min="0"
                    :max="100"
                    style="width: 100%"
                  />
                  <!-- 单选框 -->
                  <j-dict-select-tag v-if="item.type == 'radio'" type="radio" v-model="formData[item.label]" :dictCode="item.dictCode" />
                  <!-- 下拉选择 -->
                  <j-dict-select-tag v-if="item.type == 'select'" type="select" v-model="formData[item.label]" :dictCode="item.dictCode" placeholder="请选择" />
                  <!-- 下拉多选 -->
                  <j-multi-select-tag
                    v-if="item.type == 'mutiSelect'"
                    type="multi"
                    v-model="formData[item.label]"
                    :dictCode="item.dictCode"
                    placeholder="请选择"
                  />
                  <!-- 文本输入框 -->
                  <a-input v-if="item.type == 'text'" v-model.trim="formData[item.label]" placeholder="请输入" allowClear />
                  <!-- 多行文本输入框 -->
                  <a-textarea v-if="item.type == 'textarea'" v-model.trim="formData[item.label]" placeholder="请输入" showCount :rows="3" :maxlength="200" />
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>
        <!-- 自定义配置附件 -->
        <div class="uploadarea" v-if="article.configList && article.configList.length > 0">
          <template v-for="item in article.configList">
            <docUpload
              :required="item.isRequire == 1"
              :key="item.id"
              :info="item"
              :disabled="!article.allowStudy"
              :state="reviewInfo.reviewStatus"
              @change="onFileChange"
              @remove="onFileRemove"
              @changeDesc="onChangeDesc"
            />
          </template>
        </div>
        <div class="uploadarea" v-else>
          <docUpload
            required
            :info="uploadItemDefault"
            :state="reviewInfo.reviewStatus"
            :disabled="!article.allowStudy"
            @change="onFileChange"
            @remove="onFileRemove"
          />
        </div>
      </div>

      <div style="text-align: center">
        <a-button
          v-if="article.allowStudy"
          :disabled="reviewInfo.reviewStatus == '2' || reviewInfo.reviewStatus == '3'"
          type="primary"
          shape="round"
          class="btn"
          :loading="loading"
          @click="handleSubmit"
        >
          全部提交
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import docUpload from './docListUpload';

export default {
  name: 'DetailList',
  props: {
    article: Object,
    reviewInfo: Object,
  },
  components: {
    docUpload,
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'visibles' }),
      formData: {},
      delFileIds: [],
      fileList: [],
      loading: false,
      isOpen: false,
    };
  },
  computed: {
    state() {
      const statusEnum = {
        0: '待提交',
        1: '待审核',
        2: '审核通过',
        3: '教学点审核通过',
        4: '学校驳回',
        5: '教学点驳回',
        6: '待复核',
      };
      return statusEnum[this.reviewInfo.reviewStatus || '0'];
    },
    uploadItemDefault() {
      return {
        fileTitle: '文件上传',
        isInput: 0,
        fileSize: 20,
        fileNumber: 10,
        fileList: this.reviewInfo.docList || [],
      };
    },
  },
  methods: {
    backHistory() {
      this.$router.go(-1); // 返回上一层
    },
    downloadDoc(url, name) {
      this.axios
        .get(url, {
          responseType: 'blob',
        })
        .then(res => {
          const url = window.URL.createObjectURL(res);
          const el = document.createElement('a');
          el.setAttribute('href', url);
          el.setAttribute('download', name);
          el.style.display = 'none';
          document.body.appendChild(el);
          el.click();
          document.body.removeChild(el);
        })
        .catch(() => {});
    },
    // 页面提交
    handleSubmit() {
      if (this.$refs.form) {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submit();
          } else {
            this.$message.error('表单必填项不能为空');
            return false;
          }
        });
      } else {
        if (this.fileList.length === 0) {
          this.$message.error('请添加上传附件');
          return false;
        }
        this.submit();
      }
    },
    submit() {
      let params = {
        id: this.article.id,
        docList: this.fileList || [],
        delFileIds: this.delFileIds.join(','),
        docStuInfo: this.formData,
      };
      this.loading = true;
      this.axios
        .post('/biz/home/document/backUpload', params)
        .then(res => {
          if (res.success) {
            this.$message.success('提交成功', 1000);
            setTimeout(() => {
              this.$router.go(0);
            }, 500);
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onFileChange({ file, configId }) {
      this.fileList.push({
        uid: file.uid,
        docUrl: file.url,
        id: file.id,
        docName: file.name,
        fileSize: file.size,
        configId,
        remark: file.remark,
      });
    },
    onFileRemove({ id, uid }) {
      const index = this.fileList.findIndex(item => item.uid === uid);
      this.fileList.splice(index, 1);
      if (id) this.delFileIds.push(id);
    },
    onChangeDesc({ configId, desc }) {
      this.fileList.forEach(item => {
        if (item.configId === configId) {
          item.remark = desc;
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'

.content-container
  background-color #FFFFFF
.upfile
  background-color #FFFFFF
  /*margin-top 20px*/
  padding 24px

.course-notice
  margin-top 24px
  color red
  font-size 24px
  display flex
  align-items center
  justify-content center

.title
  font-size 24px
  margin-top 24px


.author
  font-size 13px
  color #999


.cl
  clear both
  padding-bottom 24px


.desc
  line-height 30px
  color $fontGray
  text-indent 2em
  padding-top 20px

.contentdetail
  margin-bottom 20px

.text
  font-size 14px
  text-align justify
  line-height 1.5
  float left
  line-height 24px
.text span
  color #fc484e
  margin-right 10px



.warp
  background-color #fefaed
  line-height 30px
  display inline-block
  position relative
  padding 10px 20px
  padding-right 60px
  width 100%
  transition height .3s


.clamp
  padding-right 60px
  overflow hidden
  display -webkit-box
  -webkit-line-clamp 1
  -webkit-box-orient vertical


.butn
  position absolute
  right 20px
  top 8px
  color #2caf7a
  cursor pointer

.docList{
  display flex
  flex-wrap wrap
}


.studentinfomation
  background-color #FFF
  width 100%
  display inline-block
  padding 24px
  padding-top 0px

.filestyle
  border-radius 10px
  border #eef1f1 solid 1px
  padding 20px
  width 100%
  height 100%
  display inline-block
  // margin-right 20px
  // margin-top 20px
.defaultcss{
  background url("../../../assets/images/defaulticon.png") no-repeat left center
  padding-left 46px
  float left
  height 30px
}
.pdfcss
  background-image url("../../../assets/images/pdficon.png")


.progressbar
  width 100%
  clear both
  padding-top 10px


.filegrey
  font-size 12px
  color #b2b2b2
  line-height 26px

.filestyle
  span
    display block

.downicon
  float right
  width 22px
  height 22px
  cursor pointer

.doccss
  background-image url("../../../assets/images/docicon.png")

.xlscss
  background-image url("../../../assets/images/xlsicon.png")


.uploadarea
  margin-top 20px
  background-color #fbfcfc



.uploadicon
  background url("../../../assets/images/uploadicon.png") no-repeat left center
  padding-left 26px


.btn
  background-color #2caf7a
  border #2caf7a solid 1px
  margin-right 14px

.progressbar
  width 100%
  clear both
  padding-top 10px
</style>
<style lang="css" scoped>
.desc >>> strong {
  font-weight: bold;
}
.ant-form-item {
  margin-bottom: 0;
}
.ant-form-inline .ant-form-item-with-help {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PracticeDetail/components/PracticeDetailForm.vue